import { query, collection, orderBy, getDocs } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import firebaseConfig from '../../config';

const { databaseId } = firebaseConfig;

function MiscFactory(firebase) {
  const getAllUsers = async () => {
    const ref = collection(firebase.fsdb, 'users');
    const q = query(ref, orderBy('name'));
    return getDocs(q);
  };

  const checkIfLoginViaMagicLinkIsAllowed = async ({ sessionId }) => {
    const checkIfLoginViaMagicLinkIsAllowedCallable = httpsCallable(
      firebase.functions,
      'misc-checkIfLoginViaMagicLinkIsAllowed'
    );
    return checkIfLoginViaMagicLinkIsAllowedCallable({
      sessionId,
      databaseId
    });
  };

  return {
    getAllUsers,
    checkIfLoginViaMagicLinkIsAllowed
  };
}

export default MiscFactory;
